<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()">
  <div class="soil-analysis-dialog">
    <mat-form-field class="full-width-field">
      <mat-label>{{ 'defaultSoilAnalysis.description' | translate }}</mat-label>

      <input matInput formControlName="description" [placeholder]="'defaultSoilAnalysis.description' | translate" data-test="soil-analysis-form-description" />
    </mat-form-field>
  </div>
  <ng-container formGroupName="characteristics">
    <h2 class="text--h3">{{ 'defaultSoilAnalysis.characteristics' | translate }}</h2>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.carbonToNitrogenRatio' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.carbonToNitrogenRatio' | translate"
          formControlName="carbonToNitrogenRatio"
          [step]="1"
          data-test="edit-manual-soil-analysis-carbonToNitrogenRatio"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.deliverableNitrogen' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.deliverableNitrogen' | translate"
          formControlName="deliverableNitrogen"
          [step]="1"
          data-test="edit-manual-soil-analysis-deliverableNitrogen"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.totalNitrogen' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.totalNitrogen' | translate"
          formControlName="totalNitrogen"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-totalNitrogen"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.minNitrogen' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.minNitrogen' | translate"
          formControlName="minNitrogen"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-minNitrogen"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.phosphorusAmmoniumLactate' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.phosphorusAmmoniumLactate' | translate"
          formControlName="phosphorusAmmoniumLactate"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-phosphorusAmmoniumLactate"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.phosphorusNumber' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.phosphorusNumber' | translate"
          formControlName="phosphorusNumber"
          [step]="1"
          data-test="edit-manual-soil-analysis-phosphorusNumber"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.plantAvailablePhosphorus' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.plantAvailablePhosphorus' | translate"
          formControlName="plantAvailablePhosphorus"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-plantAvailablePhosphorus"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.potassiumNumber' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.potassiumNumber' | translate"
          formControlName="potassiumNumber"
          [step]="1"
          data-test="edit-manual-soil-analysis-potassiumNumber"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.plantAvailableMagnesium' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.plantAvailableMagnesium' | translate"
          formControlName="plantAvailableMagnesium"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-plantAvailableMagnesium"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.calciumCarbonate' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.calciumCarbonate' | translate"
          formControlName="calciumCarbonate"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-calciumCarbonate"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.organicMatter' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.organicMatter' | translate"
          formControlName="organicMatter"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-organicMatter"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.soilAcidityNir' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.soilAcidityNir' | translate"
          formControlName="soilAcidityNir"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-soilAcidityNir"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.soilAcidity' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.soilAcidity' | translate"
          formControlName="soilAcidity"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-soilAcidity"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.ammoniaStock' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.ammoniaStock' | translate"
          formControlName="ammoniaStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-ammoniaStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.nitrateStock' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.nitrateStock' | translate"
          formControlName="nitrateStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-nitrateStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.plantAvailablePotassium' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.plantAvailablePotassium' | translate"
          formControlName="plantAvailablePotassium"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-plantAvailablePotassium"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.plantAvailableCalcium' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.plantAvailableCalcium' | translate"
          formControlName="plantAvailableCalcium"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-plantAvailableCalcium"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.calciumStock' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.calciumStock' | translate"
          formControlName="calciumStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-calciumStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.copperStock' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.copperStock' | translate"
          formControlName="copperStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-copperStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.ferroStock' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.ferroStock' | translate"
          formControlName="ferroStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-ferroStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.cationExchangeCapacity' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.cationExchangeCapacity' | translate"
          formControlName="cationExchangeCapacity"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-cationExchangeCapacity"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.calciumFilling' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.calciumFilling' | translate"
          formControlName="calciumFilling"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-calciumFilling"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.magnesiumFilling' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.magnesiumFilling' | translate"
          formControlName="magnesiumFilling"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-magnesiumFilling"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.potassiumFilling' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.potassiumFilling' | translate"
          formControlName="potassiumFilling"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-potassiumFilling"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'characteristics.sodiumFilling' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.sodiumFilling' | translate"
          formControlName="sodiumFilling"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-sodiumFilling"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.soilAvailablePotassium' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.soilAvailablePotassium' | translate"
          formControlName="soilAvailablePotassium"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-soilAvailablePotassium"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.potassiumStock' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.potassiumStock' | translate"
          formControlName="potassiumStock"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-potassiumStock"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>
          {{ 'characteristics.cecClayHumus' | translate }}
        </mat-label>
        <input
          matInput
          agrNumber
          maxlength="7"
          [placeholder]="'characteristics.cecClayHumus' | translate"
          formControlName="cecClayHumus"
          [step]="0.1"
          data-test="edit-manual-soil-analysis-cecClayHumus"
        />
      </mat-form-field>
    </div>
  </ng-container>
</agr-form-dialog>
